import "./sass/styles.scss";
import Layout from "./components/layout/Layout";
import store from "./store/store";
import { Provider } from "react-redux";
import useWindowSize from "./components/registered/companyList/search/windowResize";

function App() {
	const size = useWindowSize();

	return (
		<Provider store={store}>
			<header>
				<div className="register_logo">
					<a
						href="/"
						className="logo no-animation"
						aria-label="Offshore Qualific logo"
					>
						<svg
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							x="0px"
							y="0px"
							viewBox="0 0 425.2 207.41"
						>
							<g>
								<g>
									<path
										fill="#005F84"
										d="M230.11,63.5c-7.41,0-13.4,5.64-13.4,13.32c0,7.64,5.95,13.32,13.4,13.32c7.45,0,13.39-5.67,13.39-13.32
                  C243.51,69.14,237.53,63.5,230.11,63.5z M230.11,87.44c-5.79,0-10.46-4.71-10.46-10.62c0-5.91,4.67-10.62,10.46-10.62
                  c5.79,0,10.46,4.71,10.46,10.62C240.58,82.73,235.9,87.44,230.11,87.44z"
									/>
									<path
										fill="#005F84"
										d="M230.11,104.26c-7.41,0-13.4,5.64-13.4,13.32c0,7.64,5.95,13.32,13.4,13.32c2.98,0,5.7-0.92,7.92-2.49
                  l2.32,2.32c0.25,0.25,0.57,0.37,0.9,0.37s0.65-0.12,0.9-0.37c0.5-0.5,0.5-1.3,0-1.8l-2.2-2.2c2.21-2.34,3.56-5.52,3.56-9.15
                  C243.51,109.9,237.53,104.26,230.11,104.26z M237.9,124.68l-6.09-6.09c-0.5-0.5-1.3-0.5-1.8,0s-0.5,1.3,0,1.8l5.99,5.99
                  c-1.68,1.15-3.7,1.82-5.88,1.82c-5.79,0-10.46-4.71-10.46-10.62c0-5.91,4.67-10.62,10.46-10.62c5.79,0,10.46,4.71,10.46,10.62
                  C240.58,120.33,239.56,122.8,237.9,124.68z"
									/>
									<polygon
										fill="#005F84"
										points="255.48,76.93 264.05,76.93 264.05,74.23 255.48,74.23 255.48,66.63 264.36,66.63 264.36,63.93 
                  252.63,63.93 252.63,89.67 255.48,89.67 		"
									/>
									<polygon
										fill="#005F84"
										points="284.67,74.23 276.1,74.23 276.1,66.63 284.98,66.63 284.98,63.93 273.25,63.93 273.25,89.67 
                  276.1,89.67 276.1,76.93 284.67,76.93 		"
									/>
									<path
										fill="#005F84"
										d="M301.55,75.12l-2.47-1.08c-0.97-0.43-1.93-0.85-2.7-1.62c-0.69-0.66-0.97-1.24-0.97-2.24
                  c0-2.39,1.78-3.98,4.32-3.98c1.47,0,2.39,0.5,2.89,0.89c0.58,0.46,1.16,1.24,1.51,1.93l2.28-1.51c-0.58-1.12-1.47-2.16-2.51-2.86
                  c-1.27-0.85-2.55-1.16-4.13-1.16c-4.17,0-7.22,2.66-7.22,6.64c0,1.93,0.66,3.13,1.78,4.21c1.16,1.12,2.43,1.66,3.44,2.12
                  l2.32,1.08c1.35,0.62,2.35,1.08,3.09,1.78c0.93,0.85,1.28,1.85,1.28,3.01c0,2.59-1.66,5.1-5.17,5.1c-1.31,0-2.59-0.31-3.71-1.43
                  c-0.73-0.77-1.35-1.93-1.54-3.28l-2.78,0.77c0.35,1.54,1.12,3.32,2.39,4.56c1.78,1.74,3.9,2.08,5.6,2.08
                  c4.63,0,8.14-3.16,8.14-7.91c0-1.85-0.54-3.36-1.85-4.67C304.44,76.47,303.05,75.78,301.55,75.12z"
									/>
									<polygon
										fill="#005F84"
										points="332.55,74.39 319.35,74.39 319.35,63.93 316.49,63.93 316.49,89.67 319.35,89.67 319.35,77.09 
                  332.55,77.09 332.55,89.67 335.41,89.67 335.41,63.93 332.55,63.93 		"
									/>
									<path
										fill="#005F84"
										d="M357.92,63.5c-7.41,0-13.39,5.64-13.39,13.32c0,7.64,5.94,13.32,13.39,13.32c7.45,0,13.4-5.67,13.4-13.32
                  C371.32,69.14,365.33,63.5,357.92,63.5z M357.92,87.44c-5.79,0-10.46-4.71-10.46-10.62c0-5.91,4.67-10.62,10.46-10.62
                  c5.79,0,10.46,4.71,10.46,10.62C368.38,82.73,363.71,87.44,357.92,87.44z"
									/>
									<path
										fill="#005F84"
										d="M383.29,78.4h0.73l7.84,11.27h3.47l-8.18-11.5c3.9-0.27,6.49-3.16,6.49-7.1c0-2.74-1.31-4.71-2.82-5.71
                  c-1.93-1.31-4.52-1.43-6.25-1.43h-4.13v25.75h2.86V78.4z M383.29,66.63h1.74c1.24,0,2.55,0.08,3.71,0.73
                  c1.62,0.93,2.05,2.35,2.05,3.78c0,3.01-2.12,4.71-5.67,4.71h-1.81V66.63z"
									/>
									<polygon
										fill="#005F84"
										points="417.04,66.63 417.04,63.93 403.68,63.93 403.68,89.67 417.04,89.67 417.04,86.97 406.54,86.97 
                  406.54,76.97 416.73,76.97 416.73,74.27 406.54,74.27 406.54,66.63 		"
									/>
									<path
										fill="#005F84"
										d="M270.08,121.11c0,2.16,0,4.52-2.05,6.25c-1.04,0.89-2.82,1.47-4.25,1.47c-1.43,0-3.2-0.58-4.25-1.47
                  c-2.05-1.74-2.05-4.09-2.05-6.25v-15.79h-2.86v16.56c0,2.16,0.23,4.25,1.62,6.18c1.54,2.12,4.25,3.47,7.53,3.47
                  c3.28,0,5.98-1.35,7.53-3.47c1.39-1.93,1.62-4.02,1.62-6.18v-16.56h-2.86V121.11z"
									/>
									<path
										fill="#005F84"
										d="M280.43,131.07h3.16l3.09-7.26h10.96l3.01,7.26h3.17l-11.54-26.98L280.43,131.07z M287.8,121.11l4.4-10.31
                  l4.32,10.31H287.8z"
									/>
									<polygon
										fill="#005F84"
										points="314.17,105.32 311.32,105.32 311.32,131.07 321.28,131.07 321.28,128.37 314.17,128.37 		"
									/>
									<rect
										x="329"
										y="105.32"
										fill="#005F84"
										width="2.86"
										height="25.75"
									/>
									<polygon
										fill="#005F84"
										points="342.36,131.07 345.22,131.07 345.22,118.33 353.79,118.33 353.79,115.63 345.22,115.63 
                  345.22,108.03 354.1,108.03 354.1,105.32 342.36,105.32 		"
									/>
									<rect
										x="362.98"
										y="105.32"
										fill="#005F84"
										width="2.86"
										height="25.75"
									/>
									<path
										fill="#005F84"
										d="M374.95,118.3c0,7.45,5.67,13.24,13.32,13.24c1.93,0,4.9-0.46,7.76-2.51v-3.55
                  c-0.46,0.46-1.51,1.43-2.97,2.16c-1.35,0.7-3.05,1.2-4.79,1.2c-4.71,0-10.38-3.51-10.38-10.5c0-5.94,4.4-10.73,10.34-10.73
                  c1.51,0,3.09,0.39,4.44,1c1.31,0.62,2.55,1.58,3.36,2.39v-3.55c-3.09-2.35-6.06-2.55-7.6-2.55
                  C380.7,104.9,374.95,110.61,374.95,118.3z"
									/>
								</g>
								<path
									fill="#005F84"
									d="M170.06,170.8c17.21-17.42,27.84-41.33,27.84-67.69c0-53.15-43.24-96.38-96.38-96.38S5.14,49.96,5.14,103.11
                s43.24,96.38,96.38,96.38c25.79,0,49.25-10.19,66.57-26.75l12.3,18.58c0.26,0.39,0.69,0.61,1.13,0.61c0.26,0,0.52-0.07,0.75-0.23
                c0.63-0.41,0.8-1.26,0.38-1.88L170.06,170.8z M40.18,33.03c2.11-1.85,4.28-3.59,6.53-5.23l42.73,68.29l3.97,31.32l-43.4,53.32
                c-0.21-0.14-0.42-0.28-0.62-0.42L40.18,33.03z M48.43,179.65c-4.52-3.15-8.79-6.71-12.77-10.69
                c-17.59-17.59-27.28-40.98-27.28-65.85c0-24.88,9.69-48.26,27.28-65.86c1.19-1.19,2.41-2.34,3.66-3.46L48.43,179.65z M167.03,36.97
                L94.2,126.44l-8.14-64.31l72.13-32.94c3.21,2.47,6.28,5.16,9.19,8.07L167.03,36.97z M167.7,37.58c8.6,8.68,15.29,18.76,19.85,29.71
                l-56.16,14.89L167.7,37.58z M85.94,61.19l-6.16-48.67c7.04-1.68,14.33-2.55,21.75-2.55c20.41,0,39.82,6.53,55.85,18.59L85.94,61.19
                z M89.17,93.95L47.45,27.26c9.51-6.81,20.15-11.73,31.44-14.53L89.17,93.95z M130.41,83.38l57.42-15.23l-0.11-0.42
                c3.42,8.33,5.61,17.16,6.49,26.27L51.08,180.85L130.41,83.38z M139.34,128.35c-0.12,0.38-0.09,0.81,0.15,1.17l26.8,40.5
                c-17.46,16.92-40.4,26.22-64.77,26.22c-18.02,0-35.25-5.08-50.06-14.57L139.34,128.35z M141.75,128.03
                c-0.22-0.33-0.55-0.53-0.91-0.59L194.3,95c0.23,2.68,0.35,5.38,0.35,8.1c0,24.46-9.37,47.47-26.4,64.96L141.75,128.03z"
								/>
							</g>
						</svg>
					</a>
				</div>
			</header>
			<div
				className={
					size.width <= 1100
						? "register-process"
						: "register-process large"
				}
			>
				<Layout />
			</div>
		</Provider>
	);
}

export default App;
